module.exports = __webpack_public_path__ + "static/img/icon txzz1.eca95f53.svg";